<template>
  <!-- 重置密码页 -->
  <div class="reset-pwd cognition__content-main">
    <div class="reset-pwd__title cognition__content-title">重置密码</div>
    <div class="reset-pwd__item">
      <div class="reset-pwd__label">姓名：</div>
      <div class="reset-pwd__value">{{info.uid}}</div>
    </div>
    <div class="reset-pwd__item">
      <div class="reset-pwd__label">用户名：</div>
      <div class="reset-pwd__value">{{info.name}}</div>
    </div>
    <div class="reset-pwd__item">
      <div class="reset-pwd__label">邮箱：</div>
      <div class="reset-pwd__value">{{info.email}}</div>
    </div>
    <el-form ref="resetRef" :model="regiForm" :rules="rules">
      <el-form-item label="密码：" prop="password">
        <el-input show-password v-model="regiForm.password" placeholder="请输入密码" :maxlength="50" />
      </el-form-item>
      <el-form-item label="重复密码：" prop="doublePwd">
        <el-input show-password v-model="regiForm.doublePwd" placeholder="请再次输入密码" :maxlength="50" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onReset">重置密码</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { encryptByDES } from "@/util";
import { getResetInfoApi, resetByEmailApi, resetByTokenApi, getSecretKeyApi } from '@/util/api'

export default {
  name: "ResetPwd",
  data() {
    return {
      regiForm: {
        password: "",
        doublePwd: ""
      },
      rules: {
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { min: 6, message: "密码要大于 6 个字符", trigger: "blur" }
        ],
        doublePwd: [
          { required: true, message: "请再次输入密码", trigger: "blur" },
          { validator: this.validatePass, trigger: "blur" }
        ]
      },
      info: {
        uid: "-",
        name: "-",
        email: "-"
      }
    };
  },
  created() {
    const param = {
      token: this.$route.query.token,
      noToken: true
    };
    getResetInfoApi(param).then(res => {
      if (res.code === 0) {
        this.info.uid = res.data.uid || "-";
        this.info.name = res.data.name || "-";
        this.info.email = res.data.email || "-";
      } else {
        this.$message.error(res.msg);
      }
    });
  },
  methods: {
    validatePass(rule, value, callback) {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.regiForm.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    },
    afterReset(res) {
      if (res.code === 0) {
        this.$message({
          type: "success",
          message: "重置密码成功!"
        });
        this.$router.push("/login").catch(data => console.log(data));
      } else {
        this.$message.error(res.msg);
      }
    },
    onReset() {
      this.$refs["resetRef"].validate(valid => {
        if (valid) {
          getSecretKeyApi(this.info.uid)
          .then(res => {
            if (res.code === 0) {
              // 秘钥
              const privateKey = res.data;
              const password = encryptByDES(
                this.regiForm.password,
                privateKey
              );
              const { token } = this.$route.query;
              if (token) {
                // 通过邮箱方式修改密码
                resetByEmailApi({
                  token,
                  password
                })
                .then(this.afterReset);
              } else {
                // 登录后修改密码
                resetByTokenApi({
                  password
                })
                .then(this.afterReset);
              }
            }
          });
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style scoped lang="less">
.reset-pwd {
  .reset-pwd__title {
    margin-bottom: 26px !important;
  }
  .reset-pwd__item {
    padding-left: 160px;
    margin: 20px 0;
    color: @label-color;
    line-height: 20px;
    display: flex;
    .reset-pwd__label {
      width: 64px;
    }
    .reset-pwd__value {
      flex: 1;
    }
  }
}
</style>
